<template>
  <div class="c-page u-relative">

      <section    data-color="clear" class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel">
          <div class="c-page__header o-wrapper--panel" :style="myStylesTransform2">
            <img  :src="imageHeadSrc" class="u-absolute u-pos-tl"  :style="myStylesWidthHeight">
          </div>
          <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
              <div class="u-relative u-inline-block u-valign-bottom u-marg-l-w1of12 u-marg-b-vh1of12 u-marg-b-vh3of12@sm">
                <span class="c-page__subtitle t-h2 t-text--roman u-color--white u-inline-block u-marg-b-md" v-html="content.subtitle"></span>
                  <h1 class="t-h2-sub  t-text-lh--md u-color--white u-marg-b-lg">
                      <app-sliced-text :content="content.title"></app-sliced-text>
                  </h1>
                </div>
          </div>
      </section>

      <section  :data-color="item.dataColor"   v-for="(item, index)  in content.blocks"    class="u-relative u-pad-x-w2of12  js-header-panel"  :class="item.bgColorClass">
        <div>
          <div v-if="index===content.blocks.length-3"    class="u-absolute u-pos-tl u-fit">

           <app-scroll-object   :parallaxRatio=".05"  :OffsetHeighManual="1000"   :isParallax="!0" inline-template >
                 <div class=" c-investors__section-2__pattern u-absolute u-pos-tl u-w1of4 u-marg-b-0@sm u-margin-top-cherman-rgh u-opacity--20@sm  u-w3of4@sm">
                   <img src="../../assets/medias/images/whoweare/GrowthEmployee.png" class="u-fit-w">
                 </div>
           </app-scroll-object>
         </div>
         <div v-if="index===content.blocks.length-4"    class="u-absolute u-pos-tl u-fit">



        </div>
           <div v-if="index===content.blocks.length-5"    class="u-absolute u-pos-tl u-fit">


            <app-scroll-object   :parallaxRatio=".05"  :OffsetHeighManual="1000" :isParallax="!0" inline-template >
                  <div class="c-investors__section-2__pattern u-absolute u-pos-tl u-w3of10 u-marg-b-0@sm u-margin-top-cherman-rgh u-opacity--20@sm u-hide@sm u-w3of4@sm">
                    <img src="../../assets/medias/images/whoweare/HichamItani.png" class="u-fit-w">
                  </div>
            </app-scroll-object>

          </div>
          <div v-if="index===content.blocks.length-2"    class="u-absolute u-pos-tl u-fit">

           <app-scroll-object   :parallaxRatio=".05"  :OffsetHeighManual="1000"  :isParallax="!0" inline-template >
                 <div class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm u-opacity--20@sm u-w3of4@sm">
                   <img src="../../assets/medias/images/whoweare/Employee-RGH-LEFT.jpg" class="u-fit-w">
                 </div>
           </app-scroll-object>
         </div>
         <div v-if="index===content.blocks.length-1"    class="u-absolute u-pos-tl u-fit">

              <div class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm u-opacity--20@sm u-w3of4@sm">
                  <img src="../../assets/medias/images/whoweare/RGH-Employee-Communicaton2.jpg" class="u-fit-w" >
                </div>

        </div>

            <span  v-if="index<content.blocks.length -1"    class="c-line c-line--x u-absolute u-pos-bl u-bg--gray u-fit-w"></span>

          <div class="c-investors__section u-relative u-flex u-flex-fd--column@sm u-pad-y-xxl" v-if="item.special==='special-left'">
                  <div class="u-marg-t-xs@sm u-marg-b-xxl u-w5of8 u-w3of4@md  u-pad-l-0@lg u-fit-w@sm ">
                    <div>
                      <app-scroll-object   :offset=".05" :OffsetHeighManual="1000"  :isParallax="!1" inline-template  :content="item" >
                        <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg   u-marg-r-0@sm  " :class="{'u-color--gray':item.color==='dark','u-color--white':item.color==='white'}">
                            <span class="c-number-offset2 t-text--xl--Light u-absolute u-pos-bl" >{{index+1<10?"0"+(index+1):index+1}}</span>
                              <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                          </h3>
                      </app-scroll-object>
                    </div>
                    <div  :key="indexin"  v-for="(itemin, indexin)  in item.content">
                      <h6 class="t-text--xxl t-text-lh--md t-text--roman u-pad-t-lg"  v-if="'title'===itemin.type.value" :class="{'u-marg-t-lg':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}">
                        <app-scroll-object   :offset=".05" :OffsetHeighManual="1000"  :isParallax="!1" inline-template  :content="itemin" >
                             <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                         </app-scroll-object >
                      </h6>
                      <div class="u-marg-t-md t-text--md" v-if=" 'default'===itemin.type.value"  :class="{'u-marg-t-md':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}" v-html="itemin.content" > </div>


                      <div v-if=" 'blockquote'===itemin.type.value">
                                <app-scroll-object   :offset=".05"  :OffsetHeighManual="1000" :isParallax="!1" inline-template  :content="itemin" >
                                    <p class=" u-relative u-marg-t-lg u-pad-t-lg t-text--xxl t-text-lh--md t-text--roman-italic u-color--brand-blue">
                                      <span class="c-line--x u-absolute u-pos-tl u-fit-w u-bg--brand-blue"></span>
                                      <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                                   </p>
                                </app-scroll-object>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="c-investors__section u-relative u-flex u-flex-fd--column@sm u-pad-y-xxl"  v-if="item.special==='normal'" >
                  <app-scroll-object   :offset=".05" :OffsetHeighManual="1000"  :isParallax="!1" inline-template  :content="item" >
                          <div class="w2of10 u-w1of3@md u-fit-w@sm"  :class="{'u-marg-t-md':index==2}">
                            <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg u-marg-r-0@sm" :class="{'u-color--gray':item.color==='dark','u-color--white':item.color==='white'}">
                                  <img src="../../assets/medias/images/lgoRghPart.svg" class="c-logo-Sector-offset2 c-investors__section-2__pattern c-firstslide__whoweare__logo  u-absolute u-pos-bl" v-if="index===0">
                                  <span class="c-number-offset2 t-text--xl--Light u-absolute u-pos-bl">{{index+1<10?"0"+(index+1):index+1}}</span>
                                  <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                              </h3>
                          </div>
                    </app-scroll-object>
                    <div class="u-marg-t-sm@sm u-marg-b-xxl u-w5of8 u-w3of4@md  u-pad-l-0@lg u-fit-w@sm  u-marg-b-lg@sm   u-marg-b-xxl@">
                      <div  :key="indexin"  v-for="(itemin, indexin)  in item.content">
                          <h6 class="t-text--xxl t-text-lh--md t-text--roman"  v-if="'title'===itemin.type.value" :class="{'u-marg-t-lg':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}">
                            <app-scroll-object   :offset=".05" :OffsetHeighManual="1000"  :isParallax="!1" inline-template  :content="itemin" >
                                 <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                             </app-scroll-object >
                          </h6>
                          <div class=" u-marg-t-md t-text--md" v-if=" 'default'===itemin.type.value"  :class="{'u-marg-t-md':indexin>0,'u-marg-t-sm':index==3,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}" v-html="itemin.content" > </div>
                          <div   class="u-marg-t-sm-RGH-ligne" v-if="'true'===itemin.lineSeparator"></div>

                          <div v-if=" 'blockquote'===itemin.type.value">
                                    <app-scroll-object   :offset=".05" :OffsetHeighManual="1000"  :isParallax="!1" inline-template  :content="itemin" >
                                        <p class=" u-relative u-marg-t-lg u-pad-t-lg t-text--xxl t-text-lh--md t-text--roman-italic u-color--brand-blue">
                                          <span class="c-line--x u-absolute u-pos-tl u-fit-w u-bg--brand-blue"></span>
                                          <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                                       </p>
                                    </app-scroll-object>
                          </div>
                          </div>
                   </div>
                 </div>
                <div class="c-investors__section u-relative u-flex u-flex-fd--column@sm u-pad-y-xs u-marg-b-md@sm" v-if="item.blockquoteEXT.content.length>0" >
                  <app-scroll-object   :offset=".05" :OffsetHeighManual="1000"  :isParallax="!1" inline-template  :content="item.blockquoteEXT.title"  >
                          <div class="w2of10 u-w1of2@md u-fit-w@sm">
                            <h3 class="t-h3 t-text--roman u-relative u-color--gray u-marg-r-lg u-marg-r-0@sm  ">
                                  <span class="c-number-offset t-text--xs t-text--base-bold u-absolute u-pos-tl u-color--gray"></span>
                                  <app-words  :isActive="isActive" :delay="0" :content="content"></app-words>
                              </h3>
                          </div>
                    </app-scroll-object>
                    <div class="u-marg-b-xxl u-w5of8 u-w1of2@md  u-pad-l-0@lg u-fit-w@sm u-marg-y-md@sm"  >
                      <div   v-for="(blockq, indexinblockq)  in item.blockquoteEXT.content">

                                    <app-scroll-object  :OffsetHeighManual="1000"  :offset=".05"  :isParallax="!1" inline-template  :content="blockq" >
                                        <p class=" u-relative u-marg-t-lg u-pad-t-lg t-text--xxl t-text-lh--md t-text--roman u-color--gray">
                                          <span class="c-line--x u-absolute u-pos-tl u-fit-w u-bg--brand-rgh-dark"></span>
                                          <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                                       </p>
                                    </app-scroll-object>
                        </div>
                      </div>
                 </div>
               </div>
      </section>
      <app-footer :globalContent="globalContent" :adminContent="adminContent" ></app-footer>
  </div>
</template>
<script>
import      AppFooter  from  '../app-footer/index.vue'
import      AppScrollObject from     '../app-scroll-object/index.vue'
import      AppSlicedText  from '../app-sliced-text/index.vue'
import      AppRiskTools from   '../app-sliced-text/index.vue'
export default {
  props: {
                    debug: {
                        type: Boolean,
                        default: !1
                    },
                     adminContent: {
                         type: Object,
                         default: function() {}
                     },
                     globalContent: {
                         type: Object,
                         default: function() {}
                     },
                     headerPageSize: {
                         type: Array,
                         default: function() {}
                     }
                 },
                 components: {
                     "app-footer":AppFooter,
                     "app-scroll-object":AppScrollObject,

                     "app-sliced-text":AppSlicedText,
                     "app-risk-tools":AppRiskTools
                 },
                 computed:
                 {
                     content: function()
                     {
                         return this.adminContent.en.pages.AboutUS
                     },
                     myStylesTransform2() {
                       return {
                           transform: 'translateX('+this.headerPageSize[2]+'px) translateY('+this.headerPageSize[3]+'px) scale('+this.headerPageSize[4]+')'

                       }

                   },
                   myStylesWidthHeight() {
                      return {
                        width: this.headerPageSize[0] + "px",
                        height: this.headerPageSize[1] + "px"

                      }
                  }
                },
                 created: function() {
                     this.eventHub.$on("resize", this.onResize)
                 },
                 destroyed: function() {
                    this.eventHub.$off("resize", this.onResize)
                 },
                 mounted: function()
                 {

                     this.onResize(),
                     this.eventHub.$emit("page:ready")
                 },
                 data: function() {
                     return {
                       //imageHeadSrc:this.globalContent.nav.links[3].image.src
                       //imageHeadSrc:require('../../'+this.globalContent.nav.links[3].image.src+'')
                       imageHeadSrc:require('../../assets/medias/images/whoweare/RGH-who-we-are-Header.jpg')

                     }
                   },
                 methods: {
                     onResize: function() {}
                 }

}
</script>
<style  scoped>
.u-marg-t-sm-RGH-ligne
{
    height: 1px;
    width: 50%;
    background-color: white;
    position: relative;
    top: 25px;
}
.u-margin-b-xs-RGH{
  margin-bottom:5px;
}
.u-padding-b-xs-RGH{
  padding-bottom: 5px;
}
.u-marg-t-sm-RGH{
  margin-top: 15px;
}
.u-w1of2-RGH
{
  width:48%;
  margin-top: 240px;
}
.u-margin-top-cherman-rgh
{
    margin-top: 300px;
}
@media screen and (max-width: 770px) {
  .u-w1of2-RGH
  {
    width:90%;
    margin-top: 240px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app-page-howweare/index.vue